// Сжатие фото на клиенте (замена серверного sharp): canvas → WebP ≤1200px,
// с фолбэком на JPEG там, где кодирование WebP не поддерживается.

const MAX_DIMENSION = 1200;
const QUALITY = 0.8;

function blobToDataUrl(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(blob);
  });
}

async function canvasToDataUrl(canvas: HTMLCanvasElement): Promise<string> {
  let blob = await new Promise<Blob | null>((r) => canvas.toBlob(r, 'image/webp', QUALITY));
  if (!blob || blob.type !== 'image/webp') {
    blob = await new Promise<Blob | null>((r) => canvas.toBlob(r, 'image/jpeg', QUALITY));
  }
  if (!blob) throw new Error('Canvas encoding failed');
  return blobToDataUrl(blob);
}

/** Сжимает файл фото и возвращает data URL для постановки в офлайн-очередь. */
export async function compressImageFile(file: File): Promise<string> {
  let bitmap: ImageBitmap | HTMLImageElement;
  try {
    bitmap = await createImageBitmap(file);
  } catch {
    const img = new Image();
    img.src = URL.createObjectURL(file);
    await img.decode();
    bitmap = img;
  }

  const w = bitmap instanceof HTMLImageElement ? bitmap.naturalWidth : bitmap.width;
  const h = bitmap instanceof HTMLImageElement ? bitmap.naturalHeight : bitmap.height;
  const scale = Math.min(1, MAX_DIMENSION / Math.max(w, h));

  const canvas = document.createElement('canvas');
  canvas.width = Math.max(1, Math.round(w * scale));
  canvas.height = Math.max(1, Math.round(h * scale));
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas not available');
  ctx.drawImage(bitmap as CanvasImageSource, 0, 0, canvas.width, canvas.height);

  return canvasToDataUrl(canvas);
}
